// extracted by mini-css-extract-plugin
export default {"Evento":"Evento_Evento__nDVPy","descricao":"Evento_descricao__JMc5h","completo":"Evento_completo__6oXtE"};